// extracted by mini-css-extract-plugin
export var text = "style-module--text--1621c";
export var toast = "style-module--toast--62d95";
export var toastContainer = "style-module--toastContainer--10794";